import React from "react";
import PropTypes from "prop-types";

import { Button, Breadcrumb, Popconfirm, Space } from "antd";
import { FolderOutlined, ArrowUpOutlined, RedoOutlined, DownloadOutlined, FileZipOutlined } from "@ant-design/icons";

const propTypes = {
    currentFolderObject: PropTypes.object.isRequired,

    breadcrumbs: PropTypes.array.isRequired,
    onChangeBreadcrumbs: PropTypes.func.isRequired,
    onDownloadFolder: PropTypes.func.isRequired,

    allowZip: PropTypes.bool.isRequired,
};

const defaultProps = {
    breadcrumbs: [],
};

function BreadcrumbList(props) {
    const { list, onChangeBreadcrumbs } = props;

    return (
        <Breadcrumb separator="/" style={{ border: "1px solid #d9d9d9", padding: 4, paddingLeft: 8, paddingRight: 8 }}>
            {(list || []).map((item, index) => (
                <Breadcrumb.Item key={item?.fullname} onClick={() => onChangeBreadcrumbs(index)}>
                    <FolderOutlined /> {item?.name}
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
    );
}

const Toolbar = ({ breadcrumbs, currentFolderObject, onChangeBreadcrumbs, onDownloadFolder, allowZip }) => {
    const onClickUp = () => {
        const len = (breadcrumbs || []).length;

        if (len >= 2) {
            return onChangeBreadcrumbs(len - 2);
        }
    };

    const onClickRefresh = () => {
        const len = (breadcrumbs || []).length;

        if (len >= 0) {
            return onChangeBreadcrumbs(len - 1);
        }
    };

    const onZip = () => onDownloadFolder(currentFolderObject);

    return (
        <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
                <Space.Compact>
                    <Button disabled={(breadcrumbs || []).length <= 1} onClick={onClickUp}>
                        <ArrowUpOutlined />
                    </Button>
                    <Button onClick={onClickRefresh}>
                        <RedoOutlined />
                    </Button>
                </Space.Compact>
            </div>
            <div style={{ flex: "auto" }}>
                <BreadcrumbList
                    separator=">"
                    list={breadcrumbs}
                    onChangeBreadcrumbs={onChangeBreadcrumbs}
                    style={{ width: "100%", order: "1px solid" }}
                />
            </div>
            {allowZip && (
                <div>
                    <Space.Compact>
                        <Popconfirm
                            title="Do you want to download folder as Zip?"
                            onConfirm={onZip}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button>
                                <FileZipOutlined />
                                ZIP
                            </Button>
                        </Popconfirm>
                    </Space.Compact>
                </div>
            )}
        </div>
    );
};

Toolbar.propTypes = propTypes;
Toolbar.defaultProps = defaultProps;
export default Toolbar;
